var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "expert" },
    [
      _c("TitleBlock", { attrs: { text: _vm.title, size: "two-string" } }),
      _vm._v(" "),
      _c("ExpertCard", {
        attrs: { name: _vm.name, email: _vm.email, photo: _vm.photo },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }